import { Reducer, Action } from 'redux';
import { ObjectValues } from './types';

/**
 * FetchStatus is used to represent an async loading action. The action can be in the following states:
 *
 * None: Request is not active.
 * Loading: Request is loading.
 * Failed: Request was sent, but failed.
 * Loaded: Request completed.
 */
export enum FetchStatus {
  failed,
  loading,
  loaded,
  none,
}

interface FetchLifecycle {
  loading: any;
  failed: any;
  loaded: any;
}

/**
 * Helper to return a loading reducer, often used in combineReducers:
 *
 * combineReducers({
 *   loadStatus: fetchAction({
 *     loading: Action.Loading,
 *     failed: Action.Failed,
 *     loaded: Action.loaded,
 *   })
 * })
 */
export const fetchAction =
  <T extends FetchLifecycle>(properties: T): Reducer<FetchStatus, Action<ObjectValues<T>>> =>
  (state = FetchStatus.none, action) => {
    switch (action.type) {
      case properties.loading:
        return FetchStatus.loading;
      case properties.failed:
        return FetchStatus.failed;
      case properties.loaded:
        return FetchStatus.loaded;
    }
    return state;
  };
